// extracted by mini-css-extract-plugin
module.exports = {"nav":"navigation_nav__2WPD9","nav_inner":"navigation_nav_inner__1IPtf","links":"navigation_links__k-Wuj","link":"navigation_link__1mqGZ","logo":"navigation_logo__R32-1"};